import React from "react"
import { formatScore } from "../../utils/utils"

function ScoreBox(props) {

    let { fraud_status_events } = props

    if (fraud_status_events == null || fraud_status_events.length === 0 ||
        fraud_status_events[0].decision_metadata == null || fraud_status_events[0].decision_metadata.score == null ||
            (typeof fraud_status_events[0].decision_metadata.score === 'object' &&
            fraud_status_events[0].decision_metadata.score !== null &&
            !Array.isArray(fraud_status_events[0].decision_metadata.score) &&
            Object.keys(fraud_status_events[0].decision_metadata.score).length === 0)) {
        return (
            <div className="analysisCard" style={{ flexDirection: "row" }}>
                <div
                    className={["blueText", "subtitleSize"].join(" ")}
                    style={{ marginTop: "auto", marginBottom: "auto" }}
                >
                    Score:
                </div>
                <div className={["labelText", "subtitleSize", "labelSpace"].join(" ")} >
                    Informação Indisponível
                </div>
            </div>
        )
    }

    else {
        let scoreObject = formatScore(fraud_status_events[0].decision_metadata.score)
        return (
            <div className="analysisCard">
                <div  style={{display:'flex', flexDirection: "row", justifyContent: "space-evenly" }}>
                    <div
                        className={["blueText", "subtitleSize"].join(" ")}
                        style={{ width: '120px', marginTop: "auto", marginBottom: "auto" }}
                    >
                        Score:
                    </div>
                    <div
                        className={["circle", "medium", "bold", "normalText", "subtitleSize"].join(" ")}
                        style={{ color: "white", backgroundColor: scoreObject.color, margin: "auto 0px" }}
                    >
                        {fraud_status_events[0].decision_metadata.score}
                    </div>
                    <div className={["normalText", "subtitleSize", "bold"].join(" ")} style={{ margin: "auto 0px", color: scoreObject.color }}>
                        {scoreObject.text}
                    </div>
                    {scoreObject.icon}
                </div>
                <div style={{display:'flex', flexDirection: "row", justifyContent: "space-evenly", marginTop: '20px'}}>
                    <div
                        className={["blueText", "subtitleSize"].join(" ")}
                        style={{ width: '120px', marginTop: "auto", marginBottom: "auto" }}
                    >
                        Score - Roubo:
                    </div>
                    <div
                        className={["circle", "medium", "bold", "normalText", "subtitleSize"].join(" ")}
                        style={{ color: "white", backgroundColor: "#0b1f82", margin: "auto 0px" }}
                    >
                        {fraud_status_events[0].decision_metadata.theft_score  ?? '-'}
                    </div>
                    <div style={{width: '80px'}}></div>
                </div>
            </div>
        )

    }



}

export default ScoreBox